import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import apiInstance from "../../../services/ServiceApi";

function useMobileDetect() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isMobile;
}

function DataCuentaDetalle({ open, handleClose, identificador, id_linea_negocio, cuenta_id }) {
  const [data, setData] = useState([]);
  const isMobile = useMobileDetect();
  const [selectedRow, setSelectedRow] = useState(null);

  const renderTableHeaders = () => {
    if (!data.length) {
      return null;
    }
    const keysToRender = isMobile ? Object.keys(data[0]).slice(0, 2) : Object.keys(data[0]);
    return keysToRender.map(key => (
      <TableCell key={key} style={{ textTransform: "uppercase", padding: '16px' }}>
        {key.replace(/_/g, " ")}
      </TableCell>
    ));
  };
  
  
  const renderTableBody = () => {
    if (isMobile) {
      return data.map((row, index) => (
        <>
          <TableRow key={index}>
            {Object.values(row).slice(0, 2).map((value, i) => (
              <TableCell key={i} onClick={() => setSelectedRow(index === selectedRow ? null : index)}>
                {value}
              </TableCell>
            ))}
          </TableRow>
          {index === selectedRow && (
            <TableRow>
              <TableCell colSpan={2}>
                <Table>
                  {Object.entries(row).map(([key, value]) => (
                    <TableRow key={key}>
                      <TableCell style={{ fontWeight: "bold" }}>{key}</TableCell>
                      <TableCell>{value}</TableCell>
                    </TableRow>
                  ))}
                </Table>
              </TableCell>
            </TableRow>
          )}
        </>
      ));
    } else {
      return data.map((row, index) => (
        <TableRow key={index}>
          {Object.values(row).map((value, i) => (
            <TableCell key={i}>{value}</TableCell>
          ))}
        </TableRow>
      ));
    }
  };
  
  useEffect(() => {
    if(open) {
      apiInstance.get('/cuentaDetalle/', {params:{
        identificador,
        cuenta_id,
        id_linea_negocio
      }}).then(response => {
        setData(response.data);
      }).catch(error => {
        console.error(error);
      });
    }
  }, [open, identificador, id_linea_negocio, cuenta_id]);
  
  return (
    <Dialog open={open} onClose={handleClose} fullWidth={true} maxWidth="lg">
      <DialogTitle style={{ position: 'relative' }}>
        DETALLE
        <IconButton style={{ position: 'absolute', right: 0, top: 0 }} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <TableContainer component={Paper} style={{ margin: '20px' }}>
          <Table>
          <TableHead>
            <TableRow>
              {renderTableHeaders()}
            </TableRow>
          </TableHead>

          <TableBody>
            {renderTableBody()}
          </TableBody>

          </Table>
        </TableContainer>
      </DialogContent>
    </Dialog>
  );
}

export default DataCuentaDetalle;
